import styled from "styled-components";

export const ErrorWidgetContainer = styled.div(({ theme }) => {
    return {
        position: "fixed",
        background: theme.colors[theme.colorMode].background_Primary,
        left: 0,
        bottom: 0,
        width: "100%",
        boxShadow: "0px -3px 20px 0px rgba(0, 0, 0, 0.08)",
        borderRadius: `${theme.spacing.medium} ${theme.spacing.medium} 0 0`,
        paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.xLarge})`,
        "@supports (-webkit-touch-callout: none)": {
            "@supports (padding-bottom: env(safe-area-inset-bottom))": {
                paddingBottom: `calc(${theme.spacing.medium} + (env(safe-area-inset-bottom) / 2))`,
            },
        },
    };
});

export const TOAST_CONTAINER_CLASSNAME = "toast";

export const ToastContainer = styled.div(() => ({
    [`& .${TOAST_CONTAINER_CLASSNAME}`]: {
        bottom: "100px",
        left: 0,
        right: 0,
        marginLeft: "auto",
        marginRight: "auto",
        width: "fit-content",
        zIndex: 9,
    },
}));
